<div appFormControl class="telephone">
  <input
    (blur)="onBlur()"
    (focus)="onFocus()"
    [attr.required]="required"
    [autocomplete]="autocomplete()"
    [formControl]="control"
    [id]="id"
    [name]="name"
    [placeholder]="placeholder()"
    appFormNumericInput
    class="telephone__input"
    inputmode="tel"
    type="tel"
  />
  @if (control.value && control.enabled) {
    <app-validity-icon
      [valid]="control.valid"
      class="telephone__input-check-icon"
    />
  }
</div>
